module.exports = __webpack_public_path__ + "static/media/yongjinjiesuanxitong.613555ac.png";